import React from 'react';

import { facilityConfig } from '../../../configs/facilityConfig';

import CatalogItemResultsContainer from './CatalogItemResultsContainer';

export default function AccommodationFacilitiesResultsContainer() {
  return <CatalogItemResultsContainer config={facilityConfig} />;
}
